import { Component, Inject } from "@angular/core";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { Store } from "@ngrx/store";
import { AppState } from "@store/state";
import { Trips } from "@tendercuts/models";
import { BasePage } from "src/app/utils";

@Component({
  selector: "app-hyper-track-trip",
  templateUrl: "./hyper-track-trip.component.html",
  styleUrls: ["./hyper-track-trip.component.scss"],
})
export class HyperTrackTripComponent extends BasePage {
  trip: Trips;
  iframeSrc: SafeResourceUrl;

  constructor(
    public dialog: MatDialog,
    public snackBar: MatSnackBar,
    public store: Store<AppState>,
    public dialogRef: MatDialogRef<HyperTrackTripComponent>,
    protected sanitizer: DomSanitizer,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    super(dialog, snackBar, store);
    if (data) {
      this.trip = data.trip;
      this.iframeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(
        `https://live-track.web.app/?tripId=${this.trip.tripId}`,
      );
    }
  }

  dialogClose(): void {
    this.dialogRef.close();
  }
}
